<template>
  <div class="order-operations-list">
    <b-modal
      :active.sync="operationsModal.active"
      :width="'90vw'"
      has-modal-card
    >
      <order-operations-modal
        :order="order"
        :operation="operationsModal.operation"
        :disabled="true"
      />
    </b-modal>
    <b-modal :active.sync="notesModal.active" has-modal-card>
      <order-operation-notes-modal
        :operation-id="notesModal.operation ? notesModal.operation.id : null"
        @create-success="onNotesCreate"
      />
    </b-modal>
    <b-modal :active.sync="fileModal.active" has-modal-card>
      <file-modal
        model="order_operation"
        :model-id="fileModal.operation ? fileModal.operation.id : null"
        :viewers="fileModal.viewers"
        accept=".png, .jpg, .jpeg, .gif, .xls, .xlsx, .doc, .docx, .pdf, .csv"
        :accepted-mime-types="[
          'image/png',
          'image/jpeg',
          'image/gif',
          'application/vnd.ms-excel',
          'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
          'application/msword',
          'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
          'application/pdf',
          'text/csv',
        ]"
        @uploaded="onFileUploaded"
        @updated="onFileEvent"
        @deleted="onFileEvent"
      />
    </b-modal>
    <div style="padding: 10px">
      <b-field grouped v-if="!isBelongToIssuingFirm(order)">
        <b-select v-model="status" name="status">
          <option value="">Please select</option>
          <option value="BLRQ">BLRQ</option>
          <option value="FINALISED_NOBILLING">NOT ACTIONED</option>
        </b-select>
        <p class="control">
          <b-button
            label="SET"
            :disabled="!status || !operationsChecked.length"
            @click="setStatus"
          />
        </p>
      </b-field>
      <b-input
        placeholder="Search"
        icon-right="close-circle"
        icon-right-clickable
        @icon-right-click="
          () => (($refs.searchInput.newValue = ''), search(''))
        "
        @input="(v) => search(v)"
        ref="searchInput"
      ></b-input>
    </div>
    <b-table
      :data="operationsFiltered"
      checkable
      :checked-rows.sync="operationsChecked"
      :is-row-checkable="() => !isBelongToIssuingFirm(order)"
      detailed
      detail-key="id"
      :loading="loading"
      sticky-header
      sticky-checkbox
      ref="table"
    >
      <template slot-scope="props">
        <b-table-column field="number" custom-key="Task" label="">
          <span class="operationId">{{ props.row.operationId }}</span>
          <!-- <b-icon
            icon="info-circle"
            class="operation-tooltip"
            :title="getOperationTooltip(props.row)"
            :aria-label="getOperationAriaLabel(props.row)"
          /> -->
          <b-tooltip :label="getOperationTooltip(props.row)" type="is-dark" position="is-right" multilined>
            <b-icon class="operation-tooltip" icon="info-circle" :aria-label="getOperationAriaLabel(props.row)" />
          </b-tooltip>
        </b-table-column>

        <b-table-column field="site" custom-key="Site" label="">
          {{
            props.row.asset && props.row.asset.site
              ? `${props.row.asset.site.code.name} ${
                  props.row.asset.site.assetName ||
                  props.row.asset.site.thirdPartyCode
                }`
              : ""
          }}
        </b-table-column>

        <b-table-column field="assetClass" custom-key="Asset Class" label="">
          {{
            props.row.asset && props.row.asset.code
              ? props.row.asset.code.name
              : ""
          }}
        </b-table-column>

        <b-table-column field="description" custom-key="Description" label="">
          {{ props.row.activityCode ? props.row.activityCode.name : "" }}
          &nbsp;-&nbsp;
          {{ props.row.description || "N/A" }}
          <b-taglist>
            <b-tag
              type="is-dark"
              v-for="tag in props.row.tags || []"
              :key="tag.id"
            >
              {{ tag.name }}
            </b-tag>
          </b-taglist>
        </b-table-column>

        <b-table-column field="assetId" custom-key="Asset" label="">
          <div v-if="props.row.asset" style="white-space: nowrap">
            {{ props.row.asset ? props.row.asset.thirdPartyCode : "" }}
          </div>
        </b-table-column>

        <b-table-column field="status" custom-key="Status" label="">
          {{ props.row.status | operationStatusDisplay }}
          <!-- <template v-slot:header="{ column }">
            <b-checkbox
              :value="isBulkStatusChecked()"
              class="checkbox-bulk-status"
              :disabled="
                !(
                  (canBeCompletedByUser && canBeCompletedByUser.value) ||
                  canIssuingFirmUserUpdateOperation()
                ) || !canManageOperationsBoolean
              "
              @input="(val) => onBulkStatusInput(val)"
            >
              {{ column.label }}
            </b-checkbox>
          </template>

          <b-checkbox
            :value="props.row.status == 'COMPLETED'"
            class="checkbox-status"
            :disabled="
              !(
                (canBeCompletedByUser && canBeCompletedByUser.value) ||
                canIssuingFirmUserUpdateOperation(props.row)
              ) || !canManageOperationsBoolean
            "
            @input="(val) => onStatusInput(val, props.row)"
          /> -->
        </b-table-column>

        <b-table-column field="actions">
          <div style="white-space: nowrap">
            <template v-if="props.row.asset">
              <b-button size="is-small" @click="() => viewAsset(props.row)">
                VIEW
              </b-button>
              <b-button
                v-if="props.row.form"
                id="view_form"
                size="is-small"
                @click="() => viewForm(order, props.row)"
              >
                {{ props.row.form.id_alt }}
              </b-button>
              <b-button
                v-else-if="canInspect(order, props.row)"
                class="inspect_operation"
                size="is-small"
                @click="() => inspect(order, props.row, false)"
              >
                INSPECT
              </b-button>
            </template>
            <b-button size="is-small" @click="() => addNotes(props.row)">
              ADD NOTES
            </b-button>
            <b-button
              size="is-small"
              @click="() => uploadFile(props.row)"
              v-if="!isBelongToIssuingFirm(order)"
            >
              UPLOAD FILE
            </b-button>
            <b-button
              :type="
                props.row.status == 'FINALISED_NOBILLING'
                  ? 'is-success'
                  : 'is-danger'
              "
              size="is-small"
              :disabled="
                (canManageClaimLinesByUser &&
                  canManageClaimLinesByUser.value === 'disabled') ||
                props.row.orderOperationClaimLines.length > 0 ||
                !order.editable
              "
              @click="() => updateStatus(props.row, 'FINALISED_NOBILLING')"
              v-if="
                canInvoiceInternalOrders &&
                canManageClaimLines &&
                canManageClaimLines.value &&
                canManageClaimLinesByUser &&
                canManageClaimLinesByUser.value
              "
            >
              NOT ACTIONED
            </b-button>
            <b-button
              type="is-danger"
              size="is-small"
              v-if="canManageOperationsBoolean && canForceDeleteOperation"
              @click="() => confirmDelete(props.row)"
            >
              DELETE
            </b-button>
          </div>
        </b-table-column>
      </template>

      <template #detail="props">
        <b-collapse
          class="card"
          style="padding: 0"
          animation="slide"
          :open="false"
          v-if="canInvoiceInternalOrders"
        >
          <template #trigger="props">
            <div
              class="card-header collapse-trigger-claim-invoicing"
              role="button"
            >
              <p class="card-header-title">Claim & Invoicing</p>
              <a class="card-header-icon">
                <b-icon
                  type="is-dark"
                  :icon="props.open ? 'caret-down' : 'caret-up'"
                >
                </b-icon>
              </a>
            </div>
          </template>
          <div
            class="card-content collapse-content-claim-invoicing"
            style="padding: 0"
          >
            <div class="content" style="padding: 0">
              <table class="table is-fullwidth is-bordered">
                <tbody>
                  <!-- START - CLAIM AND INVOICING -->
                  <tr v-if="canInvoiceInternalOrders">
                    <th colspan="2">
                      <button
                        id="add_operation_claim_line"
                        class="button is-light is-small has-text-weight-bold"
                        :disabled="
                          (canManageClaimLinesByUser &&
                            canManageClaimLinesByUser.value === 'disabled') ||
                          !order.editable
                        "
                        :title="
                          canManageClaimLinesByUser &&
                          canManageClaimLinesByUser.value === 'disabled'
                            ? canManageClaimLinesByUser.help[0]
                            : ''
                        "
                        @click="() => openClaimLineModal(props.row)"
                        v-if="
                          canManageClaimLines &&
                          canManageClaimLines.value &&
                          canManageClaimLinesByUser &&
                          canManageClaimLinesByUser.value
                        "
                      >
                        ADD CLAIM LINE
                      </button>
                    </th>
                  </tr>
                  <tr v-if="canInvoiceInternalOrders">
                    <th>
                      <div class="level">
                        <div class="level-left">
                          <div class="level-item">
                            <b-field grouped>
                              <div
                                class="block"
                                v-if="
                                  canManageClaimLines &&
                                  canManageClaimLines.value &&
                                  canManageClaimLinesByUser &&
                                  canManageClaimLinesByUser.value
                                "
                              >
                                <b-radio
                                  :value="props.row.status"
                                  :name="`${props.row.id}-chargeable`"
                                  native-value="BLRQ"
                                  :disabled="
                                    (canManageClaimLinesByUser &&
                                      canManageClaimLinesByUser.value ===
                                        'disabled') ||
                                    props.row.orderOperationClaimLines
                                      .length === 0 ||
                                    !order.editable
                                  "
                                  @input="(v) => updateStatus(props.row, v)"
                                >
                                  Chargeable
                                </b-radio>

                                <b-radio
                                  :value="props.row.status"
                                  :name="`${props.row.id}-nocharge`"
                                  native-value="FINALISED_NOBILLING"
                                  :disabled="
                                    (canManageClaimLinesByUser &&
                                      canManageClaimLinesByUser.value ===
                                        'disabled') ||
                                    props.row.orderOperationClaimLines.length >
                                      0 ||
                                    !order.editable
                                  "
                                  @input="(v) => updateStatus(props.row, v)"
                                >
                                  No Charge
                                </b-radio>
                              </div>
                            </b-field>
                          </div>
                        </div>
                      </div>
                    </th>
                    <th v-if="order.billing_code">
                      <div>
                        <strong>CLAIM ID:</strong>
                        <span>{{ order.billing_code }}</span>
                      </div>
                    </th>
                  </tr>
                  <tr v-if="canInvoiceInternalOrders">
                    <td colspan="2">
                      <order-operation-claim-lines
                        :order="order"
                        :operation-id="props.row.id"
                        :operation.sync="props.row"
                        :claim-lines.sync="props.row.orderOperationClaimLines"
                        @created="() => onClaimLinesCreated(props.row)"
                        @removed="() => onClaimLinesRemoved(props.row)"
                        :ref="`${props.row.id}-claimLines`"
                        @allClaimLinesDeleted="
                          () => allClaimLinesDeleted(props.row)
                        "
                      />
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </b-collapse>
        <b-collapse
          class="card"
          style="padding: 0"
          animation="slide"
          :open="false"
          v-if="canCommentOnOperations"
        >
          <template #trigger="props">
            <div class="card-header" role="button">
              <p class="card-header-title">Logs & Notes</p>
              <a class="card-header-icon">
                <b-icon
                  type="is-dark"
                  :icon="props.open ? 'caret-down' : 'caret-up'"
                >
                </b-icon>
              </a>
            </div>
          </template>
          <div class="card-content">
            <div class="content">
              <order-operation-notes
                :operation-id="props.row.id"
                :with-comments="canCommentOnOperations"
                :ref="`${props.row.id}-notes`"
              />
            </div>
          </div>
        </b-collapse>
        <b-collapse class="card" animation="slide" :open="false">
          <template #trigger="props">
            <div class="card-header" role="button">
              <p class="card-header-title">Documents</p>
              <a class="card-header-icon">
                <b-icon
                  type="is-dark"
                  :icon="props.open ? 'caret-down' : 'caret-up'"
                >
                </b-icon>
              </a>
            </div>
          </template>
          <div class="card-content">
            <div class="content">
              <file-list
                :model="{ id: props.row.id, model_type: 'order_operation' }"
                model-type="order_operation"
                no-upload
                :ref="`${props.row.id}-files`"
              />
            </div>
          </div>
        </b-collapse>
      </template>
    </b-table>
  </div>
</template>

<script>
import OrderOperationsModal from "./OrderOperationsModal";
import OrderOperationClaimLines from "./OrderOperationClaimLines";
import OrderOperationNotes from "./OrderOperationNotes";
import OrderOperationNotesModal from "./OrderOperationNotesModal";
import FileList from "@/components/File/FileList";
import FileModal from "@/components/File/FileModal";
import { orderOperationMixin } from "@/components/Order/mixins/orderOperationMixin";
import { OrderOperationService } from "@/services/orderOperation.service";
import { OrderOperationClaimLineService } from "@/services/orderOperationClaimLine.service";
import { TagService } from "@/services/tag.service";
import { JsonDenormalizer } from "@/helpers/JsonDenormalizer";
import _ from "lodash";
import { DateFormat } from "@/helpers/date-format";
import { display as displayOperationStatus } from "@/helpers/operation-statuses";

export default {
  props: {
    order: {
      type: Object,
      required: true,
    },
    operations: {
      type: Array,
      default: () => [],
    },
  },
  mixins: [orderOperationMixin],
  components: {
    OrderOperationsModal,
    OrderOperationClaimLines,
    OrderOperationNotes,
    OrderOperationNotesModal,
    FileList,
    FileModal,
  },
  data: () => ({
    operationsModal: {
      active: false,
      operation: null,
    },
    notesModal: {
      active: false,
      operation: null,
    },
    fileModal: {
      active: false,
      operation: null,
      viewers: null,
    },
    operationsFiltered: [],
    operationsChecked: [],
    status: "",
    loading: false,
  }),
  computed: {
    canInvoiceInternalOrders() {
      if (
        this.order.createdByFirm &&
        this.order.createdByFirm.id === this.order.firm.id
      ) {
        return (
          this.order.createdByFirm.permissions.findIndex(
            (permission) => permission.name === "must invoice internal orders"
          ) > -1
        );
      }
      return true;
    },
    canCommentOnOperations() {
      if (this.order.createdByFirm) {
        return (
          this.order.createdByFirm.permissions.findIndex(
            (permission) => permission.name === "can comment on operations"
          ) > -1
        );
      }
      return true;
    },
    canManageClaimLines() {
      return this.$store.getters["OrderState/getStateByKey"](
        "can_manage_claim_lines"
      );
    },
    canManageClaimLinesByUser() {
      return this.$store.getters["OrderState/getStateByKey"](
        "can_manage_claim_lines_by_user"
      );
    },
    canBeCompletedByUser() {
      return this.$store.getters["OrderState/getStateByKey"](
        "can_be_completed_by_user"
      );
    },
    canForceDeleteOperation() {
      return this.$store.getters["Auth/hasPermission"](
        "can force delete operation"
      );
    },
    canManageOperationsBoolean() {
      // Because it's a pain to keep checking (canManageOperations && canManageOperations.value)
      const obj = this.$store.getters["OrderState/getStateByKey"](
        "can_manage_operations"
      );
      return obj && obj.value;
    },
  },
  mounted() {
    this.operationsFiltered = this.operations;
    // Pre-open operation detail
    if (this.$route.query.operationId) {
      const operation = this.operationsFiltered.find(v => v.operationId == this.$route.query.operationId);
      if (operation) {
        this.$refs.table.toggleDetails(operation);
      }
    }
  },
  watch: {
    operations(operations) {
      this.operationsFiltered = operations;
    },
  },
  methods: {
    search: _.debounce(function (value) {
      value = (value || "").toLowerCase();
      this.operationsFiltered = this.operations.filter((op) => {
        let bool = false;
        // Number
        bool = bool
          ? bool
          : `${op.operationId || ""}`.toLowerCase().search(value) > -1;
        // Owner
        bool = bool
          ? bool
          : `${op.ownerFirm ? op.ownerFirm.name : ""}`
              .toLowerCase()
              .search(value) > -1;
        // Task
        bool = bool
          ? bool
          : `${op.activityCode ? op.activityCode.name : ""}`
              .toLowerCase()
              .search(value) > -1;
        // Asset Class
        bool = bool
          ? bool
          : `${op.asset && op.asset.code ? op.asset.code.name : ""}`
              .toLowerCase()
              .search(value) > -1;
        // Asset ID
        bool = bool
          ? bool
          : `${op.asset ? op.asset.thirdPartyCode : ""}`
              .toLowerCase()
              .search(value) > -1;
        // Site Name
        bool = bool
          ? bool
          : `${op.asset && op.asset.site ? op.asset.site.assetName : ""}`
              .toLowerCase()
              .search(value) > -1;
        // Description
        bool = bool
          ? bool
          : `${op.description || ""}`.toLowerCase().search(value) > -1;
        // Status
        bool = bool
          ? bool
          : `${op.status || ""}`.toLowerCase().search(value) > -1;
        // Status (short)
        bool = bool
          ? bool
          : `${displayOperationStatus(op.status)}`.toLowerCase().search(value) > -1;

        return bool;
      });
    }, 500),
    async setStatus() {
      try {
        // Get valid operations
        const operations = this.operationsChecked
          .filter(
            (op) =>
              (this.canBeCompletedByUser && this.canBeCompletedByUser.value) ||
              this.canIssuingFirmUserUpdateOperation(this.order, op)
          )
          .filter((op) =>
            this.operationsFiltered.find((opf) => opf.id == op.id)
          );

        if (operations.length == 0) return;

        // Update operations status (API)
        const operationIds = operations.map((v) => v.id);
        let operations_ = await OrderOperationService.updateStatus(
          operationIds.join(","),
          { status: this.status, includes: "orderOperationClaimLines" }
        ).then((response) => JsonDenormalizer.denormalize(response));
        // If there's only 1 operation checked
        if (!Array.isArray(operations_)) {
          operations_ = [operations_];
        }

        // Update operation status (UI) and claim lines
        operations.forEach((op) => {
          const operation = operations_.find((opp) => opp.id == op.id);
          if (operation) {
            op.status = operation.status;
            op.orderOperationClaimLines = operation.orderOperationClaimLines;
          }
        });

        // Set order state
        this.$store.dispatch("OrderState/fetchState", this.order.id);
        this.$buefy.toast.open({
          message: "Order operations status has been updated.",
          type: "is-info",
          position: "is-top-right",
        });
      } catch (err) {
        console.error(err);
      }
    },
    async updateStatus(operation, status, includes = undefined) {
      try {
        this.loading = true;
        const operation_ = await OrderOperationService.updateStatus(
          operation.id,
          { status, includes }
        ).then((response) => JsonDenormalizer.denormalize(response));

        const operationIndex = this.operations.findIndex(
          (v) => v.id == operation.id
        );
        if (operationIndex > -1) {
          this.$set(
            this.operations[operationIndex],
            "status",
            operation_.status
          );
          // Update includes
          if (includes) {
            includes.split(",").forEach((v) => {
              if (operation_[v]) {
                this.$set(this.operations[operationIndex], v, operation_[v]);
              }
            });
          }
        }

        // Set order state
        this.$store.dispatch("OrderState/fetchState", this.order.id);

        this.$buefy.toast.open({
          message:
            status == "REJECTED"
              ? "Order operation has been deleted."
              : "Order operation status has been updated.",
          type: "is-info",
          position: "is-top-right",
        });

        if (status == "REJECTED") {
          this.$emit("order-operation-deleted", operation);
        }

        return operation_;
      } catch (err) {
      } finally {
        this.loading = false;
      }
    },
    // async onStatusInput(checked, operation) {
    //   try {
    //     const status = checked ? "COMPLETED" : "APPROVED";
    //     const operation_ = await this.updateStatus(
    //       operation,
    //       status,
    //       "orderOperationClaimLines"
    //     );
    //     // Update operation claim lines
    //     const operationIndex = this.operations.findIndex(
    //       (v) => v.id == operation.id
    //     );
    //     if (operationIndex > -1) {
    //       this.operations[operationIndex].orderOperationClaimLines =
    //         operation_.orderOperationClaimLines;
    //     }

    //     // Moved to API
    //     // Create claim line only if there are no existing claim lines
    //     // if (checked && (operation.orderOperationClaimLines || []).length == 0) {
    //     //   const rateId = operation.maintenanceTask
    //     //     ? operation.maintenanceTask.rate_id
    //     //     : null;
    //     //   if (rateId) {
    //     //     const claimLine = await OrderOperationClaimLineService.create(
    //     //       operation.id,
    //     //       {
    //     //         orderOperationClaimServiceId: rateId,
    //     //         quantity: 1,
    //     //       }
    //     //     ).then((response) => JsonDenormalizer.denormalize(response));
    //     //     // Append created claim line to operation
    //     //     const operationIndex = this.operations.findIndex(
    //     //       (v) => v.id == operation.id
    //     //     );
    //     //     if (operationIndex > -1) {
    //     //       this.operations[operationIndex].orderOperationClaimLines.push(
    //     //         claimLine
    //     //       );
    //     //     }
    //     //   }
    //     // }
    //   } catch (err) {
    //     console.error(err);
    //   }
    // },
    // isBulkStatusChecked() {
    //   return this.operationsFiltered
    //     .filter(
    //       (op) =>
    //         (this.canBeCompletedByUser && this.canBeCompletedByUser.value) ||
    //         this.canIssuingFirmUserUpdateOperation(op)
    //     )
    //     .every((v) => v.status === "COMPLETED");
    // },
    // async onBulkStatusInput(checked) {
    //   try {
    //     const status = checked ? "COMPLETED" : "APPROVED";
    //     // Check/Uncheck all checkboxes
    //     this.operationsFiltered
    //       .filter(
    //         (op) =>
    //           (this.canBeCompletedByUser && this.canBeCompletedByUser.value) ||
    //           this.canIssuingFirmUserUpdateOperation(op)
    //       )
    //       .forEach((op) => (op.status = status));
    //     // Bulk update operations status
    //     const operationIds = this.operationsFiltered
    //       .filter(
    //         (op) =>
    //           (this.canBeCompletedByUser && this.canBeCompletedByUser.value) ||
    //           this.canIssuingFirmUserUpdateOperation(op)
    //       )
    //       .map((v) => v.id);
    //     let operations = await OrderOperationService.updateStatus(
    //       operationIds.join(","),
    //       { status, includes: "orderOperationClaimLines" }
    //     ).then((response) => JsonDenormalizer.denormalize(response));
    //     if (!Array.isArray(operations)) {
    //       operations = [operations];
    //     }
    //     // Update operation claim lines
    //     this.operationsFiltered.forEach((op) => {
    //       const operation = operations.find((opp) => opp.id == op.id);
    //       // this.$set(op, "orderOperationClaimLines", operation.orderOperationClaimLines);
    //       if (operation) {
    //         op.orderOperationClaimLines = operation.orderOperationClaimLines;
    //       }
    //     });
    //     // Set order state
    //     this.$store.dispatch("OrderState/fetchState", this.order.id);
    //     this.$buefy.toast.open({
    //       message: "Order operations status has been updated.",
    //       type: "is-info",
    //       position: "is-top-right",
    //     });
    //   } catch (err) {
    //     console.error(err);
    //   }
    // },
    viewAsset(operation) {
      this.operationsModal.active = true;
      this.operationsModal.operation = operation;
    },
    openClaimLineModal(operation) {
      this.$refs[`${operation.id}-claimLines`].onCreate();
    },
    onClaimLinesCreated(operation) {
      // Set order state
      this.$store.dispatch("OrderState/fetchState", this.order.id);
      // Update operation status to BLRQ when the first claim line is added
      this.$nextTick(() => {
        if (operation.orderOperationClaimLines.length === 1) {
          // this.status = "BLRQ";
          this.updateStatus(operation, "BLRQ");
        }
      });
    },
    onClaimLinesRemoved(operation) {
      // Set order state
      this.$store.dispatch("OrderState/fetchState", this.order.id);
      // Update operation status to "FINALISED_NOBILLING" when all claim lines are deleted
      this.$nextTick(() => {
        if (operation.orderOperationClaimLines.length === 0) {
          // this.status = "FINALISED_NOBILLING";
          this.updateStatus(operation, "FINALISED_NOBILLING");
        }
      });
    },
    allClaimLinesDeleted(operation) {
      if (operation.status != "APPROVED") {
        if (operation.orderOperationClaimLines.length == 0) {
          // this.status = "APPROVED";
          this.updateStatus(operation, "APPROVED");
        }
      }
    },
    addNotes(operation) {
      this.notesModal.active = true;
      this.notesModal.operation = operation;
    },
    onNotesCreate(note) {
      if (this.$refs[`${this.notesModal.operation.id}-notes`]) {
        this.$refs[`${this.notesModal.operation.id}-notes`].onCreateSuccess(
          note
        );
      }
    },
    async uploadFile(operation) {
      if (!this.fileModal.viewers) {
        await TagService.findtags({
          tags: ["customer", "vendor", "colleagues"],
        }).then((response) => {
          this.fileModal.viewers = JsonDenormalizer.denormalize(response);
        });
      }
      this.fileModal.active = true;
      this.fileModal.operation = operation;
    },
    onFileEvent() {
      if (this.$refs[`${this.fileModal.operation.id}-files`]) {
        this.$refs[`${this.fileModal.operation.id}-files`].fetch();
      }
    },
    onFileUploaded() {
      if (this.fileModal.operation) {
        this.updateStatus(
          this.fileModal.operation,
          "BLRQ",
          "orderOperationClaimLines"
        );
      }
      this.onFileEvent();
    },
    confirmDelete(operation) {
      this.$buefy.dialog.confirm({
        title: "Deleting activity",
        message: "Are you sure you want to <b>delete</b> this activity?",
        confirmText: "Delete activity",
        type: "is-danger",
        hasIcon: true,
        onConfirm: () => this.updateStatus(operation, "REJECTED"),
      });
    },
    getOperationTooltip(operation) {
      return `Required Start: ${DateFormat.toLocalDateAndTime(
        operation.requiredStart
      )}\nRequired Finish: ${DateFormat.toLocalDateAndTime(
        operation.requiredFinish
      )}`;
    },
    getOperationAriaLabel(operation) {
      return `Required Date: ${DateFormat.toLocalDateAndTime(
        operation.requiredStart
      )} - ${DateFormat.toLocalDateAndTime(operation.requiredFinish)}`;
    },
  },
};
</script>

<style lang="scss" scoped>
.b-table .level:not(.top) {
  padding-bottom: 0;
}
</style>

<style lang="scss">
.b-table .table-wrapper.has-sticky-header {
  height: 100%;
}
.b-table {
  .detail {
    & > td,
    & > * > .detail-container {
      padding: 0 !important;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/Order/OrderOperationsList.vue